import { useRole } from '../../state';

const useEmailLimitsPermissions = (): {
  canViewCampaignBreakdown: boolean;
  canViewMonthlyBreakdown: boolean;
} => {
  const { role } = useRole();
  return {
    canViewCampaignBreakdown: role.projects.mode === 'all',
    canViewMonthlyBreakdown: role.billing.mode === 'all',
  };
};

export default useEmailLimitsPermissions;
